import { render, staticRenderFns } from "./help-blog.vue?vue&type=template&id=5c611360&"
import script from "./help-blog.vue?vue&type=script&lang=js&"
export * from "./help-blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports